import * as React from "react";
import Box from "@mui/material/Box";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import { Control, useController } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { PatientFormValues } from "../patient-form.component";
import { EMAIL_REGEX } from "utils/validations.utils";

type EmailFieldProps = {
  control: Control<PatientFormValues, object>;
};

export default function EmailField({ control }: EmailFieldProps) {
  const {
    field,
    formState: { errors },
  } = useController({
    name: "email",
    control,
    rules: {
      pattern: {
        value: EMAIL_REGEX,
        message: "Email is not valid.",
      },
    },
  });

  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      <MailOutlineIcon sx={{ mt: "30px", mr: 1.5 }} />
      <TextField
        fullWidth
        label="Email Address"
        {...(Boolean(errors?.email?.message)
          ? { error: true, helperText: errors?.email?.message }
          : {})}
        {...field}
      />
    </Box>
  );
}
